import { axios } from "@LIBS";
import { Constants } from "@CONFIG";
const InvoiceEndpoints = {
  invoice: "api/invoices/list-invoices",
  pods: "api/invoices/list-pods",
};

const previewFile = async (url) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/invoices/preview/${url}`,
    method: "GET",
    responseType: "blob",
  });

  return response;
};
const downloadInvoices = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/invoices/download-invoices`,
    data: values,
    method: "POST",
  });

  return response;
};
const downloadPods = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/invoices/download-pods`,
    data: values,
    method: "POST",
  });

  return response;
};

export { InvoiceEndpoints, previewFile, downloadInvoices, downloadPods };
